function entryPermissionFactory(PatientObjectPermission) {
  return PatientObjectPermission;
}

entryPermissionFactory.$inject = ['PatientObjectPermission'];

export default entryPermissionFactory;



/** WEBPACK FOOTER **
 ** ./src/app/patients/forms/entry-permission.js
 **/